import axios from "axios";
import BaseService, { METHODS } from "./baseApiService";
import { Bounce, toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;
const APP_ID = process.env.REACT_APP_APP_ID;

class AuthService extends BaseService {
  async login(email, password) {
    const response = await this._doRequest(METHODS.POST, "/auth/login-with-email-password", {
      email,
      password,
      type: "admin",
    });

    if (response.mfaRequired) {
      return response;
    }

    if (response.token) {
      localStorage.setItem("token", response.token);
      localStorage.setItem("refreshToken", response.refresh_token);
    }

    return response;
  }

  async verifyMfaLogin({ pendingToken, code, useBackupCode = false }) {
    const response = await this._doRequest(METHODS.POST, "/auth/mfa/verify", {
      pendingToken,
      code,
      useBackupCode,
    });
    this.storeAuthTokens(response);
    return response;
  }

  async sendMfaRecoveryEmail(pendingToken) {
    return this._doRequest(METHODS.POST, "/auth/mfa/recovery/send-email", {
      pendingToken,
    });
  }

  async verifyMfaRecovery({ pendingToken, code }) {
    const response = await this._doRequest(METHODS.POST, "/auth/mfa/recovery/verify", {
      pendingToken,
      code,
    });
    this.storeAuthTokens(response);
    return response;
  }

  async startMfaEnrollment({ method, enrollmentToken }) {
    return this._doRequest(METHODS.POST, "/auth/mfa/enrollment/start", {
      method,
      enrollmentToken,
    });
  }

  async completeMfaEnrollment({ code, enrollmentToken }) {
    const response = await this._doRequest(METHODS.POST, "/auth/mfa/enrollment/complete", {
      code,
      enrollmentToken,
    });
    this.storeAuthTokens(response);
    return response;
  }

  storeAuthTokens(response) {
    if (response?.token) {
      localStorage.setItem("token", response.token);
      localStorage.setItem("refreshToken", response.refresh_token);
    }
  }

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    window.location.reload();
  }

  async refreshToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    const response = await this._doRequest(METHODS.POST, "/refresh", {});
    if (response.accessToken) {
      user.accessToken = response.accessToken;
      localStorage.setItem("user", JSON.stringify(user));
    }
    return response;
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  async checkAuth() {
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(`${API_URL}/auth/refresh`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "noodlz-app-id": APP_ID,
        },
      });

      if (data.token) {
        localStorage.setItem("token", data.token);
      }
    } catch (e) {
      try {
        const refreshToken = localStorage.getItem("refreshToken");
        const { data } = await axios.post(`${API_URL}/auth/refresh`, {
          refresh_token: refreshToken,
        }, {
          headers: {
            "noodlz-app-id": APP_ID,
          },
        });

        if (data.token) {
          localStorage.setItem("token", data.token);
        }
      } catch (refreshError) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        window.location.href = "/#/auth/login";
      }
    }
  }

  _handleError(message) {
    this.toastId = toast(message, {
      transition: Bounce,
      closeButton: true,
      autoClose: 5000,
      position: "bottom-center",
      type: "error",
    });
  }
}

export default new AuthService();
